export const fixAndroidKeyboard = () => {
  const inputClass = 'cx-message-input';
  const chatContainerClass = 'cx-docked-WebChat';
  const inputElement = document.getElementsByClassName(inputClass).length
    ? document.getElementsByClassName(inputClass)[0]
    : undefined;
  const chatContainer = document.getElementsByClassName(chatContainerClass).length
    ? (document.getElementsByClassName(chatContainerClass) as HTMLCollectionOf<HTMLElement>)[0]
    : undefined;

  chatContainer?.classList.add('keyboard-opened');

  const isInputClicked = (target) =>
    target === inputElement ||
    (target.nodeName === 'svg' && target.namespaceURI === 'http://www.w3.org/2000/svg') ||
    (target.nodeName === 'path' && target.classList.contains('cx-svg-icon-tone1'));

  const toggleHeight = (event) => {
    const isClickedOnInput = isInputClicked(event.target);
    if (isClickedOnInput && !chatContainer?.classList.contains('keyboard-opened')) {
      chatContainer?.classList.add('keyboard-opened');
    }
    if (!isClickedOnInput && chatContainer?.classList.contains('keyboard-opened')) {
      chatContainer?.classList.remove('keyboard-opened');
    }
  };
  if (inputElement) {
    document.addEventListener('click', (event) => toggleHeight(event));
  }
};
